import React from "react";

import { HeroMediaText } from "../../hero-elements/HeroMediaText/HeroMediaText";
import { HeroTeaser } from "../../hero-elements/HeroTeaser/HeroTeaser";
import { HeroText } from "../../hero-elements/HeroText/HeroText";
import { HeroSplit} from "../../hero-elements/HeroSplit/HeroSplit";
import { HeroTextReduced } from "../../hero-elements/HeroTextReduced/HeroTextReduced";
import { isLightBackground } from "../Background/Background";
import ElementContext from "../ElementContext";

function HeroElementRenderer(props) {
    const items = props.items ?? [];

    const headerElementMap = {
        DatoCmsHeroText: HeroText,
        DatoCmsHeroMediaText: HeroMediaText,
        DatoCmsHeroSplit: HeroSplit,
        DatoCmsHeroTeaser: HeroTeaser,
        DatoCmsHeroTextReduced: HeroTextReduced,
    };

    return (
        <>
            {props.children}

            {items.map((headerElement, index) => {
                if (!headerElement.id) {
                    console.warn(
                        "The header element needs to have an ID.",
                        headerElement
                    );
                    return null;
                }

                if (!headerElement?.type) {
                    console.warn(
                        "The header element needs to have a type attribute!.",
                        headerElement
                    );
                    return null;
                }

                const HeroElement =
                    headerElementMap[headerElement.type] ?? null;

                if (!HeroElement) {
                    console.warn(
                        "There was no internal component found for this header element.",
                        headerElement
                    );
                    return null;
                }

                const initialValue = {
                    isLightBg: isLightBackground(headerElement?.background)
                }

                return (
                    <ElementContext.Provider value={initialValue} key={headerElement.id + index}>
                        <HeroElement
                            key={headerElement.id}
                            locale={props.locale}
                            data={headerElement}
                            type={headerElement.internal?.type}
                        />
                    </ElementContext.Provider>
                );
            })}
        </>
    );
}

export { HeroElementRenderer };
